import React, { Component } from "react";
import MetaTags from "react-meta-tags";

//Verification code package
import AuthCode from "react-auth-code-input";
import PropTypes from "prop-types";

import { Link, withRouter } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Row,
} from "reactstrap";

// import images
import logodark from "../../assets/images/logo-dark.png";
import logolight from "../../assets/images/logo-dark.png";
import { connect } from "react-redux";
import { loginUser, setUserInfo } from "store/actions";
import axios from "axios";
import API from "helpers/api_helper";

class TwostepVerification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      code: null,
      loading: false,
    };
  }

  componentDidMount() {
    const { location, history } = this.props;
    // if (!location.state?.email) {
    //   history.replace("/login");
    // }
  }

  handleVerify = async () => {
    const { code } = this.state;
    const { location, setUser, history } = this.props;
    this.setState({ loading: true });
    try {
      const res = await API.common.auth.login({
        scope: "*",
        grant_type: "password",
        client_id: 2,
        client_secret: "oyKpAIjCPrQUFKkDmZdqC4oVzUS10rAlmjLhnohI",
        username: location.state.mobile,
        password: code,
      });
      if (typeof res !== "undefined") {
        localStorage.setItem(
          "authUser",
          JSON.stringify({ ...res, type: location.state.type })
        );
        setTimeout(() => {
          this.setState({ loading: false });
          history.push("/dashboard");
        }, 2000);
      } else {
        throw res;
      }
    } catch (error) {
      this.setState({ loading: false });
      console.log("ERROR CODE 245 : ", error);
    }
  };

  render() {
    const { account } = this.props;
    const { loading } = this.state;
    return (
      <React.Fragment>
        <div className="account-pages my-5 pt-sm-5">
          <MetaTags>
            <title>خانه من | تاییدیه همراه</title>
          </MetaTags>
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mb-5 text-muted">
                  <Link to="dashboard" className="d-block auth-logo">
                    <img
                      src="/logo512.png"
                      alt=""
                      height="40"
                      className="auth-logo-dark mx-auto"
                    />
                    <img
                      src="/logo512.png"
                      alt=""
                      height="80"
                      className="auth-logo-light mx-auto"
                    />
                  </Link>
                  <p className="mt-3">اعتبار سنجی پنل ادمین خانه من</p>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card>
                  <CardBody>
                    <div className="p-2">
                      <div className="text-center">
                        <div className="avatar-md mx-auto">
                          <div className="avatar-title rounded-circle bg-light">
                            <i className="bx bxs-envelope h1 mb-0 text-primary"></i>
                          </div>
                        </div>
                        <div className="p-2 mt-4">
                          <h4>اعتبار سنجی</h4>
                          <p className="mb-5">
                            چهار رقم ارسال شده به دستگاه خود را وارد کنید{" "}
                            <span className="font-weight-semibold">
                              {/* {location.state?.email} */}
                            </span>
                          </p>

                          <Form dir="ltr">
                            <Row>
                              <Col xs={12}>
                                <FormGroup className="verification">
                                  <label
                                    htmlFor="digit1-input"
                                    className="sr-only"
                                  >
                                    Dight 1
                                  </label>
                                  <AuthCode
                                    characters={4}
                                    onChange={code => this.setState({ code })}
                                    value
                                    className="form-control form-control-lg text-center"
                                    allowedCharacters="^[0-9]"
                                    inputStyle={{
                                      width: "76px",
                                      height: "42px",
                                      padding: "8px",
                                      borderRadius: "8px",
                                      fontSize: "16px",
                                      textAlign: "center",
                                      marginRight: "15px",
                                      border: "1px solid #ced4da",
                                      textTransform: "uppercase",
                                      color: "balck !important",
                                    }}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                          </Form>
                          {loading ? (
                            <div className="mt-4">
                              <Button
                                color="success"
                                block
                                type="button"
                                className="bg-gold"
                              >
                                <i className="bx bx-loader bx-spin font-size-16 align-middle" />{" "}
                                درحال برسی
                              </Button>
                            </div>
                          ) : (
                            <div className="mt-4">
                              <Button
                                className="bg-gold"
                                color="success"
                                block
                                onClick={this.handleVerify}
                              >
                                سنجش کد
                              </Button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-5 text-center">
                  <p>
                    آیا کد را دریافت نکرده اید ؟{" "}
                    <Link to="/login" className="fw-medium text-primary">
                      {" "}
                      ارسال مجدد{" "}
                    </Link>{" "}
                  </p>
                  <p>© {new Date().getFullYear()} خانه من.</p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

TwostepVerification.propTypes = {
  account: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object,
  loginUser: PropTypes.func,
  setUser: PropTypes.func,
};

const mapStateToProps = state => ({
  account: state.Account,
});
const mapDispatchToProps = dispatch => ({
  loginUser: user => dispatch(loginUser(user)),
  setUser: info => dispatch(setUserInfo(info)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TwostepVerification)
);
